import { call, delay, put, takeEvery } from 'redux-saga/effects';
import { HealAPI } from '../../healApi';
import { ConciergeActionKey, setAgencies, setFetchingAgencies } from './actions';

export function* getAgencies(): any {
  yield delay(250); // TODO: Why was a delay added here?
  yield put(setFetchingAgencies(true));
  const result = yield call(HealAPI.fetchAgencies);
  if (result.data) {
    yield put(setAgencies(result.data.data));
  }
  yield put(setFetchingAgencies(false));
}

export function* agenciesFlow() {
  yield takeEvery(ConciergeActionKey.FETCH_AGENCIES, getAgencies);
}
